import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerSurgeonComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Surgeon"} />
            <CMRSliderComponent type={SliderType.Surgeon} title={"Rotate"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"surgeon"}
                payload={"Surgeon"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Surgeon} />
        </>
    );
};

export default DrawerSurgeonComponent;
